export class CountryLanguage {
  idCountry: number;
  idLanguage: number;
  name: string;
  locked: boolean;

  constructor(idCountry: number, idLanguage: number, name: string, locked: boolean) {
    this.idCountry = idCountry;
    this.idLanguage = idLanguage;
    this.name = name;
    this.locked = locked;
  }

  static fromRaw(raw: any): CountryLanguage {
    return new CountryLanguage(
      Number(raw.idCountry ?? raw.id_country),
      Number(raw.idLanguage ?? raw.id_language),
      String(raw.name),
      Boolean(raw.locked),
    );
  }

  clone(): CountryLanguage {
    return new CountryLanguage(
      this.idCountry,
      this.idLanguage,
      this.name,
      this.locked,
    );
  }

  toPayload(): any {
    return {
      idCountry: this.idCountry,
      idLanguage: this.idLanguage,
      name: this.name,
      locked: this.locked,
    };
  }
}